import {Injectable, OnDestroy} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';
import {DeliveryAvailabilityModel} from "../../deliveries/models/delivery.availability.model";
import {OrderRequest} from "../api/order.request.model";
import {OrderRestService} from './order.rest.service';

@Injectable({
  providedIn: 'root',
})
export class OrderService implements OnDestroy{
  private ngUnsubscribe$ = new Subject<any>();

  constructor(private orderRestService: OrderRestService){

  }

  newOrder(request: OrderRequest) {
    console.log("newOrder: "+ request);
        return this.orderRestService.createOrder(request)
      .pipe(takeUntil(this.ngUnsubscribe$));
  }

  /**
   * Unsubscribe from all subscriptions.
   */
  ngOnDestroy(): void {
    // This aborts all HTTP requests.
    //this.ngUnsubscribe$.next();
    // This completes the subject properlly.
    this.ngUnsubscribe$.complete();
  }
}
